import { required, shape } from '@totalsoft/pure-validations';

export const itemValidator = shape({ code: required, name: required, typeId: required });
